"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _static = require("../static");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _createCusomerOrder = _interopRequireDefault(require("./createCusomerOrder.vue"));
var _selectCompay = _interopRequireDefault(require("../../../business/supplier/coupons/selectCompay.vue"));
var _SelectCardType = _interopRequireDefault(require("@/components/cardType/SelectCardType.vue"));
var _nextCustomerorder = _interopRequireDefault(require("./nextCustomerorder.vue"));
var _importMessage = _interopRequireDefault(require("./importMessage.vue"));
var _camiList = _interopRequireDefault(require("./camiList.vue"));
var _projectInfoEdit = _interopRequireDefault(require("./projectInfoEdit.vue"));
var _cardDetailApi = require("@/api/cardDetailApi");
var _auth = require("@/utils/auth");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CreateCusomerOrder: _createCusomerOrder.default,
    SelectCompay: _selectCompay.default,
    SelectCardType: _SelectCardType.default,
    NextCustomerorder: _nextCustomerorder.default,
    ImportMessage: _importMessage.default,
    CamiList: _camiList.default,
    ProjectInfoEdit: _projectInfoEdit.default
  },
  data: function data() {
    return {
      userTypeDic: {},
      miniProgramCustomer: false,
      miniProgramCustomerId: false,
      orderStateOption: _static.orderStateOption,
      customerOrderOptions: _static.customerOrderOptions,
      customerStateOptions: _static.customerStateOptions,
      kamiTypeOptions: _static.kamiTypeOptions,
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        fuCardId: ''
      },
      listData: {
        page: {
          list: [],
          total: 0
        },
        total: 0,
        statusList: [],
        customerList: [],
        companyList: [],
        appList: [],
        cardTypeList: []
      },
      listLoading: true,
      exportLoading: false,
      // 订单导出loading
      appOptions: [],
      // 小程序选项
      companyOptions: [],
      // 公司选项
      debugInfo: null,
      // 调试信息
      batchUpdateDialog: {
        visible: false
      },
      currentOrderId: null,
      // 当前操作的订单ID
      uploadAction: "".concat(process.env.VUE_APP_BASE_API, "/api/admin/order/kami/upload/secretPassword"),
      // 上传地址
      uploadHeaders: {
        'Authori-zation': (0, _auth.getToken)() // 注意这里使用的是Authori-zation，保持与项目一致
      } // 上传请求头
    };
  },
  created: function created() {
    if (this.$getHomeType()) {
      this.userTypeDic = this.$getHomeType();
    }
    this.miniProgramCustomer = suplierCouponsApi.getHomeType();
    this.miniProgramCustomerId = suplierCouponsApi.getCustomerId();
    this.getAppList();
    this.getCompanyList();
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    // 获取小程序列表
    getAppList: function () {
      var _getAppList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _cardDetailApi.getMiniappList)();
            case 1:
              res = _context.v;
              if (res && Array.isArray(res)) {
                this.appOptions = res.map(function (item) {
                  return {
                    id: item.id,
                    name: item.appName
                  };
                });

                // 更新listData中的appList
                if (!this.listData.appList) {
                  this.listData.appList = [];
                }
                this.listData.appList = this.appOptions;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error('获取小程序列表失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getAppList() {
        return _getAppList.apply(this, arguments);
      }
      return getAppList;
    }(),
    // 获取公司列表
    getCompanyList: function () {
      var _getCompanyList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return suplierCouponsApi.getAllCompany('');
            case 1:
              res = _context2.v;
              if (res && Array.isArray(res)) {
                this.companyOptions = res.map(function (item) {
                  return {
                    id: item.id,
                    name: item.name || ''
                  };
                }).filter(function (item) {
                  return item.name;
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('获取公司列表失败:', _t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getCompanyList() {
        return _getCompanyList.apply(this, arguments);
      }
      return getCompanyList;
    }(),
    // 根据公司ID获取公司名称
    getCompanyName: function getCompanyName(companyId, companyName) {
      if (!companyId) return '--';
      var company = this.companyOptions.find(function (item) {
        return item.id === companyId;
      });
      return company ? company.name : companyName ? companyName : companyId;
    },
    handerSearch: function handerSearch() {
      var _this = this;
      var doRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (doRefresh == 1) {
        // 保留重要的搜索条件
        var preservedParams = {
          page: 1,
          limit: this.$constants.page.limit[0],
          status: this.listPram.status,
          customerId: this.listPram.customerId,
          appId: this.listPram.appId,
          orderName: this.listPram.orderName,
          projectNumber: this.listPram.projectNumber,
          companyId: this.listPram.companyId,
          fuCardId: this.listPram.fuCardId,
          sendProjectId: this.listPram.sendProjectId,
          sendType: this.listPram.cardTypeId,
          // 发卡类型ID
          dateValueNum: this.listPram.dateValueNum,
          kamiType: this.listPram.kamiType,
          innerCompanyName: this.listPram.innerCompanyName,
          bindPhone: this.listPram.bindPhone,
          secretPassword: this.listPram.secretPassword
        };
        // 只保留有值的参数
        this.listPram = {};
        Object.keys(preservedParams).forEach(function (key) {
          var value = preservedParams[key];
          // 保留有效值：非空字符串、非空数组、数字0也保留
          if (value !== undefined && value !== null && value !== '' && !(Array.isArray(value) && value.length === 0)) {
            _this.listPram[key] = value;
          }
        });
        // 确保基础分页参数
        this.listPram.page = 1;
        this.listPram.limit = this.$constants.page.limit[0];
      }
      ;
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      console.log('handlerGetListData', this.listPram);
      this.listLoading = true;
      this.debugInfo = null; // Reset debug info
      // 构建请求参数对象
      var requestParams = _objectSpread(_objectSpread({}, this.listPram), {}, {
        supplierType: 1
      });
      // 确保status参数作为数字类型传递（后端可能期望数字类型）
      if (requestParams.status !== undefined && requestParams.status !== '') {
        requestParams.status = Number(requestParams.status);
      }
      console.log('请求参数:', requestParams);
      customerOrderApi.ListArticle(requestParams).then(function (response) {
        console.log('API返回数据结构:', response);

        // 处理标准API响应格式 {code: 200, message: "操作成功", data: {...}}
        if (response && response.code === 200) {
          // 从标准API响应中提取数据
          var apiData = response.data;
          console.log('从标准API返回格式中获取数据:', apiData);

          // 更新公司列表
          if (apiData.companyList) {
            console.log('获取到公司列表:', apiData.companyList.length, '条数据');
            _this2.listData.companyList = apiData.companyList;
          } else {
            console.log('API响应中没有companyList数据');
          }

          // 更新状态列表
          if (apiData.statusList) {
            _this2.listData.statusList = apiData.statusList;
          }

          // 更新发卡类型列表
          if (apiData.cardTypeList) {
            console.log('获取到发卡类型列表:', apiData.cardTypeList.length, '条数据');
            _this2.listData.cardTypeList = apiData.cardTypeList;
          } else {
            console.log('API响应中没有cardTypeList数据');
          }

          // 更新页面数据
          if (apiData.page) {
            console.log('获取到页面数据, page.list长度:', apiData.page.list ? apiData.page.list.length : 0);
            _this2.listData.page = apiData.page;
          } else {
            // 如果没有page对象，初始化为空
            _this2.listData.page = {
              list: [],
              total: 0
            };
          }
        } else {
          // 如果不是标准API响应格式，尝试其他格式
          if (response && response.data) {
            // 处理嵌套在data字段中的情况
            _this2.listData = response.data;
            console.log('从response.data中获取数据');

            // 确保cardTypeList数据被正确处理
            if (_this2.listData.cardTypeList) {
              console.log('备用分支获取到发卡类型列表:', _this2.listData.cardTypeList.length, '条数据');
            }
          } else {
            // 如果是直接返回的数据
            _this2.listData = response;
            console.log('直接使用response作为数据');

            // 确保cardTypeList数据被正确处理
            if (_this2.listData.cardTypeList) {
              console.log('直接分支获取到发卡类型列表:', _this2.listData.cardTypeList.length, '条数据');
            }
          }
        }

        // 确保page和page.list属性存在
        if (!_this2.listData.page) {
          _this2.listData.page = {
            list: [],
            total: 0
          };
          _this2.debugInfo = JSON.stringify({
            error: 'No page property in response',
            listData: _this2.listData
          }, null, 2);
        } else if (!_this2.listData.page.list) {
          // 如果page对象存在但list不存在，创建一个空列表
          _this2.listData.page.list = [];
          _this2.debugInfo = JSON.stringify({
            error: 'No list property in page',
            page: _this2.listData.page
          }, null, 2);
        } else {
          // 列表数据存在，打印日志
          console.log('列表数据加载成功，共', _this2.listData.page.list.length, '条记录');
        }
        _this2.listLoading = false;
        console.log('最终的listData:', _this2.listData);
      }).catch(function (err) {
        console.error('获取列表数据失败:', err);
        _this2.listData.page = {
          list: [],
          total: 0
        };
        _this2.debugInfo = JSON.stringify({
          error: err.message || 'Unknown error',
          stack: err.stack
        }, null, 2);
        _this2.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    selectCompany: function selectCompany(companyId) {
      console.log('选择公司:', companyId);
      this.$set(this.listPram, 'companyId', companyId);
      this.handerSearch();
    },
    selectCardType: function selectCardType(cardType) {
      this.$set(this.listPram, 'sendType', cardType);
      console.log('发卡类型ID', cardType);
      console.log('listPram', this.listPram);
      this.handerSearch();
    },
    // 新增/编辑订单
    updateCustomerOrder: function updateCustomerOrder(orderNo) {
      this.$refs['CreateCusomerOrderRef'].initOpen(orderNo);
    },
    // 变更状态
    changeCustomerState: function changeCustomerState(row) {
      this.$refs['NextCustomerorderRef'].initOpen({
        id: row.orderId,
        orderName: row.orderName,
        status: row.status,
        appId: row.appId || this.listPram.appId,
        appName: row.appName,
        quantity: row.quantity
      });
    },
    // 删除订单
    handlerDelete: function handlerDelete(orderId) {
      var _this3 = this;
      this.$confirm('确定删除当前数据', '提示').then(function (result) {
        customerOrderApi.DelArticle(orderId).then(function (data) {
          _this3.$message.success('删除数据成功');
          _this3.handerSearch(1);
        });
      });
    },
    handelPopupModel: function handelPopupModel(row) {
      var _this4 = this;
      this.$confirm("\u786E\u5B9A\u4F5C\u5E9F".concat(row.orderId, " ").concat(row.orderName, "-").concat(row.customerName, "\u7684\u8BA2\u5355\u5417\uFF1F"), '提示').then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(result) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _context3.n = 1;
                return customerOrderApi.getCustomerOrderClose(row.orderId);
              case 1:
                _this4.$message.success('订单已作废！');
                _this4.handerSearch(1);
              case 2:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 卡密短信发送
    sendMessage: function sendMessage(orderId) {
      this.$refs['ImportMessageRef'].initOpen(orderId);
    },
    openCamiDetail: function openCamiDetail(orderId) {
      this.$refs['CamiListRef'].initOpen(orderId);
    },
    // 导出卡密
    downloadCami: function downloadCami(id) {
      customerOrderApi.downLoadKami(id).then(function (res) {
        window.open(res.fileName);
      });
    },
    handleKMemeitExprot: function () {
      var _handleKMemeitExprot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return customerOrderApi.getKMDetailsExprot(_objectSpread({}, this.listPram));
            case 1:
              res = _context4.v;
              window.open(res.fileName);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleKMemeitExprot() {
        return _handleKMemeitExprot.apply(this, arguments);
      }
      return handleKMemeitExprot;
    }(),
    // 订单导出
    handleOrderExport: function () {
      var _handleOrderExport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.exportLoading = true;
              _context5.p = 1;
              _context5.n = 2;
              return customerOrderApi.exportCustomerOrder(_objectSpread({}, this.listPram));
            case 2:
              res = _context5.v;
              if (res && res.fileName) {
                window.open(res.fileName);
              } else {
                this.$message.warning('导出失败，未获取到下载地址');
              }
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              this.$message.error('订单导出失败，请重试');
              console.error('订单导出失败:', _t3);
            case 4:
              _context5.p = 4;
              this.exportLoading = false;
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function handleOrderExport() {
        return _handleOrderExport.apply(this, arguments);
      }
      return handleOrderExport;
    }(),
    handelSharchEdit: function handelSharchEdit() {
      this.handlerGetListData();
    },
    getStatusName: function getStatusName(status) {
      // 从statusList中查找匹配的状态
      if (this.listData.statusList && this.listData.statusList.length > 0) {
        var statusItem = this.listData.statusList.find(function (item) {
          return item.id === status;
        });
        return statusItem ? statusItem.status : '';
      }
      // 如果没有statusList或未找到匹配项，使用transformState作为后备方案
      return this.transformState(_static.customerStateOptions, status, 'value');
    },
    // 处理状态改变事件
    handleStatusChange: function handleStatusChange(val) {
      // 确保状态即使是0或1这样的值也能正确传递
      console.log('状态已变更为:', val);
      this.handerSearch();
    },
    // 格式化优惠券包显示
    formatCouponPackages: function formatCouponPackages(packages) {
      if (!packages || !packages.length) return '--';
      return packages.map(function (pkg) {
        return "[".concat(pkg.id, "]").concat(pkg.name);
      }).join(', ');
    },
    // 编辑项目信息
    editProjectInfo: function editProjectInfo(row) {
      this.$refs.ProjectInfoEditRef.open(row);
    },
    // 批量更新卡密
    editKami: function editKami(row) {
      // 保存当前操作的订单ID
      this.currentOrderId = row.orderId;
      // 打开批量更新对话框
      this.batchUpdateDialog.visible = true;
    },
    // 下载模板
    downloadTemplate: function downloadTemplate() {
      var _this5 = this;
      var testUrl = 'https://fucaiyijia.mynatapp.cc/crmebimage/uploadf/excel/template/kami_upload.xls';
      var prodUrl = 'https://admin.fucaiyijia.com/crmebimage/crmebimage/uploadf/excel/template/kami_upload.xls';

      // 使用 window.open 避免DOM操作引起的屏幕闪烁
      var testWindow = window.open(testUrl, '_blank');

      // 延迟1.5秒后自动尝试正式环境，确保至少有一个下载成功
      setTimeout(function () {
        var prodWindow = window.open(prodUrl, '_blank');
        _this5.$message.success('模板下载完成');
      }, 1500);
    },
    // 文件上传前的验证
    beforeUpload: function beforeUpload(file) {
      // 检查文件类型
      var isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel' || file.name.endsWith('.csv');
      if (!isExcel) {
        this.$message.error('只能上传.xlsx/.xls/.csv文件!');
        return false;
      }

      // 检查文件大小（10MB）
      var isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过10MB!');
        return false;
      }
      return true;
    },
    // 文件上传成功
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      this.$message.success('文件上传成功，正在处理中...');
      // 关闭对话框并清理状态
      this.closeBatchUpdateDialog();
      // 刷新列表
      this.handerSearch(1);
    },
    // 文件上传失败
    handleUploadError: function handleUploadError(err, file, fileList) {
      this.$message.error('文件上传失败，请重试');
      console.error('上传失败:', err);
    },
    // 关闭批量更新对话框
    closeBatchUpdateDialog: function closeBatchUpdateDialog() {
      this.batchUpdateDialog.visible = false;
      this.currentOrderId = null; // 清空当前订单ID
    }
  }
};